// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalDetail_form__3Q9lc"};